module.exports = __webpack_public_path__ + "static/media/sutros1954Cd02.fd58b5a5.jpg";